import { isRouteErrorResponse } from 'react-router';

export type RouteErrorKind = 'not-found' | 'outdated' | 'unexpected';

/** Messages of Chrome, Firefox and Safari, and of Vite's CSS preload, when a lazy page's file no longer exists. */
const MISSING_CHUNK = /dynamically imported module|importing a module script failed|unable to preload css/i;

export const getRouteErrorKind = (error: unknown): RouteErrorKind => {
  if (isRouteErrorResponse(error)) {
    return error.status === 404 ? 'not-found' : 'unexpected';
  }

  return error instanceof Error && MISSING_CHUNK.test(error.message) ? 'outdated' : 'unexpected';
};
